/*
 * Copyright (c) 2026. BrightNight. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */

import { useCallback, useEffect, useState } from 'react';

/** What the floating Agent chip reports while the Agent is closed. */
export type AgentLauncherStatus = 'idle' | 'working' | 'new_reply';

export const LAUNCHER_LABEL: Record<AgentLauncherStatus, string> = {
  idle: 'AGENT',
  working: 'Working',
  new_reply: 'New reply',
};

/**
 * Tracks the active conversation's run for the chip: "working" while a turn runs, "new reply"
 * when one finished while the Agent was closed, until the Agent is opened again.
 */
export const useAgentLauncherStatus = (isAgentOpen: boolean) => {
  const [running, setRunning] = useState(false);
  const [unseenReply, setUnseenReply] = useState(false);

  const reportRunning = useCallback(
    (next: boolean) => {
      setRunning((previous) => {
        if (previous && !next && !isAgentOpen) setUnseenReply(true);
        return next;
      });
    },
    [isAgentOpen],
  );

  useEffect(() => {
    if (isAgentOpen) setUnseenReply(false);
  }, [isAgentOpen]);

  let status: AgentLauncherStatus = 'idle';
  if (running) status = 'working';
  else if (unseenReply) status = 'new_reply';

  return { status, reportRunning };
};
